import { useState } from "react";
import { FcGoogle } from "react-icons/fc";

const Section1 = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleGoogleLogin = () => {
    console.log("Google Login Clicked");
  };

  const sendOtp = async () => {
    try {
      const response = await fetch("http://%PUBLIC_URL%/api/auth/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone }),
      });

      const data = await response.json();
      if (response.ok) {
        alert("OTP Sent Successfully!");
        setOtpSent(true);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("OTP Request Failed:", error);
    }
  };

  const verifyOtp = async () => {
    try {
      const response = await fetch(
        "http://localhost:5000/api/auth/verify-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone, otp }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("token", data.token);
        setIsAuthenticated(true);
        alert("Login Successful!");
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error("OTP Verification Failed:", error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-semibold text-center mb-6">
          {isAuthenticated ? "Welcome Back!" : "Login to your account"}
        </h2>

        {!isAuthenticated ? (
          <>
            {/* Google Login Button */}
            <button
              onClick={handleGoogleLogin}
              className="flex items-center justify-center w-full border px-6 py-3 rounded-lg shadow-md hover:bg-gray-100"
            >
              <FcGoogle size={24} className="mr-2" />
              Continue with Google
            </button>

            <div className="flex items-center my-4">
              <hr className="flex-grow border-gray-300" />
              <span className="px-2 text-gray-500 text-sm">
                or continue with mobile number
              </span>
              <hr className="flex-grow border-gray-300" />
            </div>

            {/* Phone Number Input */}
            <div className="flex items-center border px-4 py-2 rounded-lg w-full">
              <span className="mr-2">🇮🇳 +91</span>
              <input
                type="text"
                className="outline-none flex-1"
                placeholder="Enter phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            {!otpSent ? (
              <button
                onClick={sendOtp}
                className="bg-blue-600 text-white w-full py-3 rounded-lg mt-4 shadow-md hover:bg-blue-700"
              >
                Send OTP
              </button>
            ) : (
              <>
                <div className="flex items-center border px-4 py-2 rounded-lg w-full mt-4">
                  <input
                    type="text"
                    className="outline-none flex-1"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </div>

                <button
                  onClick={verifyOtp}
                  className="bg-green-600 text-white w-full py-3 rounded-lg mt-4 shadow-md hover:bg-green-700"
                >
                  Verify OTP
                </button>
              </>
            )}

            <p className="text-xs text-gray-500 mt-4 text-center">
              By logging in, you agree to the following{" "}
              <a href="#" className="text-blue-600">
                Terms of Use
              </a>{" "}
              and{" "}
              <a href="#" className="text-blue-600">
                Privacy Policy
              </a>
            </p>

            <div className="mt-2 flex justify-center space-x-4 text-xs">
              <a href="#" className="text-gray-500 hover:text-blue-600">
                Disclaimer
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-600">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-600">
                Terms of Use
              </a>
            </div>
          </>
        ) : (
          <p className="text-green-600 text-center">You are logged in!</p>
        )}
      </div>
    </div>
  );
};

export default Section1;

// import React, { useState } from "react";

// const Section1 = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!email || !password) {
//       setError("Please fill in all fields");
//       return;
//     }

//     setError("");
//     console.log("Logging in with:", { email, password });
//     alert("Login successful!");
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-100">
//       <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-sm">
//         <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">
//           Login
//         </h2>

//         {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div>
//             <label className="block mb-1 text-sm font-medium text-gray-700">
//               Email
//             </label>
//             <input
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//               placeholder="Enter your email"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 text-sm font-medium text-gray-700">
//               Password
//             </label>
//             <input
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//               placeholder="Enter your password"
//             />
//           </div>

//           <button
//             type="submit"
//             className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-300"
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Section1;

// import React, { useState } from "react";

// const Section1 = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!email || !password) {
//       setError("Please fill all the fields");
//       return;
//     }
//     setError("");
//     console.log("logged in with:", { email, password });
//     alert("Login Successful");
//   };

//   return (
//     <div className="bg-gray-100 min-h-screen flex justify-center items-center ">
//       <div className="bg-white rounded-lg p-10">
//         <form onSubmit={handleSubmit}>
//           <h2 className="text-center">Login</h2>
//           <div>
//             <label className="block mb-3">Email</label>
//             <input
//               type="email"
//               value={email}
//               placeholder="enter mail"
//               className="border  w-full px-4 py-2"
//               onChange={(e) => setEmail(e.target.value)}
//             />
//           </div>
//           <div>
//             <label className="block mb-3 mt-2">Password</label>
//             <input
//               type="password"
//               placeholder="enter password"
//               className="border  w-full px-4 py-2"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//             />
//           </div>
//           <div>
//             <button
//               type="submit"
//               className="bg-blue-400 mt-4 rounded-lg w-full"
//             >
//               Submit
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Section1;
